<template>
<v-container fluid full-width>
    <v-layout row wrap>
        <v-flex>
            <v-subheader class="headline"> {{ this.$route.name  }}</v-subheader>
        </v-flex>
  </v-layout>
</v-container>
</template>

<script>
export default {};
</script>
